import { last, uniq } from 'lodash-es'

import { ItineraryRailBooking, RailDirection, RailSlice } from '@/travelsuit'
import { TripDirection } from '@/types/trip'

export const getRailsDepartureDatetime = ({ rails }: { rails: RailSlice[] }) => rails[0].segments[0].departure.datetime

export function getRailMinMaxDates(rail: ItineraryRailBooking) {
	const startDate = getRailsDepartureDatetime(rail)
	const endDate =
		last(last(rail.rails)?.segments)?.arrival.datetime ||
		/* open_return */ last(rail.rails[0].segments)?.arrival.datetime
	return uniq([startDate.split('T')[0], endDate!.split('T')[0]])
}
export const trainTypeByNumOfStops = (num: number): RailDirection => {
	if (num === 2) {
		return TripDirection.RoundTrip
	}
	return TripDirection.OneWay
}
